// Onglets "weekly" : la config ne stocke que le slug du client Weekly, l'URL embarquée
// (verrouillée sur ce client par jail=true) est construite à l'affichage.

// Hôte des URLs Weekly saisies jusqu'ici dans des onglets "embed" (production)
export const WEEKLY_HOST = 'weekly.globe-groupe.com';

// Même règle que les slugs de l'administration Weekly
export const WEEKLY_SLUG_PATTERN = /^[a-z0-9-]+$/;

// Paramètres de jail compris par Weekly (?jail=true, ?jailed=true), désactivés par false ou 0
const JAIL_PARAMS = ['jail', 'jailed'];
const JAIL_OFF_VALUES = ['false', '0'];

/**
 * Vérifie qu'une valeur est un slug Weekly (minuscules, chiffres et tirets)
 * @param {any} slug - La valeur à vérifier
 * @returns {boolean}
 */
export const isValidWeeklySlug = (slug) => typeof slug === 'string' && WEEKLY_SLUG_PATTERN.test(slug);

/**
 * Construit l'URL de la page d'un client Weekly, verrouillée sur ce client
 * @param {string} baseUrl - L'URL de l'application Weekly (WEEKLY_APP_URL)
 * @param {string} clientSlug - Le slug du client dans Weekly
 * @returns {string}
 */
export const buildWeeklyUrl = (baseUrl, clientSlug) => {
  const weeklyUrl = new URL(`${baseUrl}/w/${encodeURIComponent(clientSlug)}`);
  weeklyUrl.searchParams.append('jail', 'true');
  return weeklyUrl.toString();
};

/**
 * Analyse une URL Weekly de production
 * @param {string} value - L'URL à analyser
 * @returns {null|{clientSlug: string}|{reason: string}} - null si ce n'est pas une URL Weekly,
 *   { clientSlug } pour la page d'un client, { reason } si l'URL ne se réduit pas à un slug
 */
export const parseWeeklyUrl = (value) => {
  let url;
  try {
    url = new URL(String(value ?? '').trim());
  } catch (e) {
    return null;
  }

  if (url.hostname !== WEEKLY_HOST) return null;

  const match = url.pathname.match(/^\/w\/([^/]+)\/?$/);
  if (!match) return { reason: `page non gérée (${url.pathname})` };

  const clientSlug = match[1];
  if (!isValidWeeklySlug(clientSlug)) return { reason: `slug invalide (${clientSlug})` };

  for (const [name, paramValue] of url.searchParams) {
    if (!JAIL_PARAMS.includes(name)) return { reason: `paramètre non géré (${name})` };
    if (JAIL_OFF_VALUES.includes(paramValue.toLowerCase())) return { reason: `jail désactivé (${name}=${paramValue})` };
  }

  if (url.hash) return { reason: `ancre non gérée (${url.hash})` };

  return { clientSlug };
};
